import Checkout from "components/Checkout";

const PublicLimitedCompanyPage = () => (
  <Checkout companyType="Public Limited Company" self />
);

export default PublicLimitedCompanyPage;
